import SignIn from 'umg-ember-backend/components/sign-in';

<template><SignIn /></template>
